import { Alert, Flex } from 'antd';
import { StyledButton } from '@app/components/button/Button';
import { FaMasksTheater } from 'react-icons/fa6';
import { MdLogout } from 'react-icons/md';
import type { Me } from '@app/services/api.types';
import CountdownTimer from './CountdownTimer';

export type ImpersonateBannerProps = {
    handleEndImpersonation: () => void;
    impersonatedUser: Me | undefined;
};

export const ImpersonateBanner = ({
    handleEndImpersonation,
    impersonatedUser,
}: ImpersonateBannerProps) => {
    const { first_name, last_name, email } = impersonatedUser || {};

    return (
        <Alert
            showIcon={false}
            type="warning"
            description={
                <Flex align="center" justify="space-between" wrap={true} gap={10}>
                    <Flex align="center" justify="space-between" gap={10}>
                        <div>
                            <FaMasksTheater size={24} style={{ display: 'block' }} />
                        </div>
                        <div>
                            Impersonating:{' '}
                            <strong>
                                {first_name} {last_name}
                            </strong>{' '}
                            ({email})
                        </div>
                        <CountdownTimer />
                    </Flex>
                    <StyledButton
                        size="small"
                        type="primary"
                        shape="round"
                        icon={<MdLogout />}
                        onClick={handleEndImpersonation}>
                        Client Logout
                    </StyledButton>
                </Flex>
            }
        />
    );
};

export default ImpersonateBanner;
